// Тонкие SVG-иконки (24px, stroke 1.75). Совместимы по духу с Lucide/Tabler.
import type { SVGProps } from 'react'

const base = { width: 18, height: 18, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.75, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const }

export const IconNodes = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base} {...p}><rect x="3" y="4" width="18" height="6" rx="1.5"/><rect x="3" y="14" width="18" height="6" rx="1.5"/><circle cx="7" cy="7" r=".5" fill="currentColor" stroke="none"/><circle cx="7" cy="17" r=".5" fill="currentColor" stroke="none"/></svg>
)
export const IconTasks = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base} {...p}><path d="M8 6h13"/><path d="M8 12h13"/><path d="M8 18h13"/><path d="M3 6l1.5 1.5L7 5"/><path d="M3 12l1.5 1.5L7 11"/><path d="M3 18l1.5 1.5L7 17"/></svg>
)
export const IconClients = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base} {...p}><circle cx="9" cy="8" r="3.5"/><path d="M2 20c0-3.5 3-6 7-6s7 2.5 7 6"/><path d="M17 11a2.5 2.5 0 100-5"/><path d="M22 20c0-2.5-1.7-4.5-4-5.3"/></svg>
)
export const IconSites = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base} {...p}><circle cx="12" cy="12" r="9"/><path d="M3 12h18"/><path d="M12 3c2.5 3 4 6 4 9s-1.5 6-4 9c-2.5-3-4-6-4-9s1.5-6 4-9z"/></svg>
)
export const IconDatabase = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base} {...p}><ellipse cx="12" cy="5" rx="8" ry="3"/><path d="M4 5v6c0 1.7 3.6 3 8 3s8-1.3 8-3V5"/><path d="M4 11v6c0 1.7 3.6 3 8 3s8-1.3 8-3v-6"/></svg>
)
export const IconDBUsers = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base} {...p}><ellipse cx="12" cy="5" rx="8" ry="3"/><path d="M4 5v6c0 1.7 3.6 3 8 3s8-1.3 8-3V5"/><path d="M4 11v6c0 1.7 3.6 3 8 3"/><circle cx="18" cy="17" r="2"/><path d="M14 21c0-1.7 1.8-3 4-3s4 1.3 4 3"/></svg>
)
export const IconFTP = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base} {...p}><path d="M12 3v14"/><path d="M6 9l6-6 6 6"/><path d="M4 21h16"/></svg>
)
export const IconCron = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base} {...p}><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>
)
export const IconKey = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base} {...p}><circle cx="8" cy="15" r="4"/><path d="M11 12l9-9"/><path d="M17 6l2 2"/><path d="M15 8l2 2"/></svg>
)
export const IconDocs = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base} {...p}><path d="M6 3h9l5 5v13H6z"/><path d="M14 3v5h5"/><path d="M9 13h7"/><path d="M9 17h5"/></svg>
)
export const IconLogout = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base} {...p}><path d="M9 4H5v16h4"/><path d="M16 15l4-3-4-3"/><path d="M20 12H10"/></svg>
)
export const IconIP = (p: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <circle cx="12" cy="12" r="9"/>
    <path d="M3 12h18"/>
    <path d="M12 3a15 15 0 0 1 0 18"/>
    <path d="M12 3a15 15 0 0 0 0 18"/>
  </svg>
)

export const IconExternal = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base} {...p}><path d="M14 4h6v6"/><path d="M20 4l-9 9"/><path d="M18 14v5a1 1 0 01-1 1H5a1 1 0 01-1-1V7a1 1 0 011-1h5"/></svg>
)
export const IconPlus = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base} {...p}><path d="M12 5v14M5 12h14"/></svg>
)
export const IconTrash = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base} {...p}><path d="M4 7h16"/><path d="M9 7V4h6v3"/><path d="M6 7l1 13h10l1-13"/></svg>
)
export const IconEdit = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base} {...p}><path d="M4 20h4l10-10-4-4L4 16z"/><path d="M14 6l4 4"/></svg>
)
export const IconShield = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base} {...p}><path d="M12 3l8 3v6c0 5-3.5 8.5-8 9-4.5-.5-8-4-8-9V6z"/><path d="M9 12l2 2 4-4"/></svg>
)
export const IconCert = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base} {...p}><path d="M4 5h16v10H4z"/><path d="M4 15v3l4-1.5L12 18l4-1.5L20 18v-3"/><circle cx="12" cy="10" r="2"/></svg>
)
export const IconFolder = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base} {...p}><path d="M3 6a2 2 0 012-2h4l2 2h8a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V6z"/></svg>
)
export const IconFile = (p: SVGProps<SVGSVGElement>) => (
  <svg {...base} {...p}><path d="M6 3h9l5 5v13H6z"/><path d="M14 3v5h5"/></svg>
)
export const IconCircleDot = ({ tone = 'gray', ...p }: SVGProps<SVGSVGElement> & { tone?: 'green'|'blue'|'yellow'|'red'|'gray' }) => {
  const colors: Record<string, string> = { green: '#16a34a', blue: '#2563eb', yellow: '#ca8a04', red: '#dc2626', gray: '#a3a3a3' }
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" {...p}>
      <circle cx="5" cy="5" r="4" fill={colors[tone]} opacity="0.25"/>
      <circle cx="5" cy="5" r="2.5" fill={colors[tone]}/>
    </svg>
  )
}
